import React, { useMemo } from 'react';
import Select from 'react-select'
import { useProfileState } from 'context/profile'
import { useTranslation } from 'react-i18next'
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

export default function TenantMembersSelect({ showMembers, val = [], ...rest }) {

    const { t } = useTranslation();
    const { groups } = useProfileState();

    const groupsOptions = useMemo(() => groups?.filter(g => g.name !== 'unassigned')
        .map((group) => ({ label: group.name, value: group._id, isGroup: true })) ?? []
        , [groups]);

    const memberOptions = useMemo(() => !showMembers ? [] : groups?.map(group => ({
        label: group.name,
        options: group.members?.map((member) =>
            ({ label: `${member.givenName} ${member.familyName}`, value: member._id, isGroup: false, } ?? []))
    })), [groups, showMembers]);

    const value = rest.isMulti ?
        val.map((v) => ({ label: groupsOptions.find((e) => (e.value === v))?.label, value: v })) :
        showMembers ?
            memberOptions.find(g => g.options?.some(m => m.value === val))?.options.find(o => o.value === val) :
            groupsOptions.filter(({ value }) => value === val)

    return (
        <Select
            value={value}
            styles={reactSelectStyles}
            placeholder={t('common.select_option')}
            noOptionsMessage={() => t('common.no_options')}
            options={showMembers ? memberOptions : groupsOptions}
            {...rest}
        />
    )
}